import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import _find from 'lodash/find';

// Components
import compactCurrencyFilter from '../../../../components/product/PricingUtils';
import ProductColorPicker from '../../common/ProductColorPicker/ProductColorPicker';

// Util
import { srcsetHelper } from '../../../util/imageHelper';
import featureFlags from '../../../../util/featureFlags';

// Constants
import { CARD_TYPE } from '../../../constants/Cards';

import './ListingDetail.less';

export default class ListingDetail extends Component {
  constructor(props) {
    super(props);

    this.handleSelectColor = this.handleSelectColor.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleTrackingProductClickedEvent = this.handleTrackingProductClickedEvent.bind(this);

    const { card: { colors }, filterColor, initialVariationColor } = props;

    // default activeColorObject is the first object in colors array
    let activeColorObject = colors && colors[0];

    if (filterColor || initialVariationColor) {
      // if there is a filter color, find the color with nrf_color_code label that matches
      // the filterColor
      const foundColorObject = _find(colors, data => (filterColor ? data.nrf_color_code_label.toUpperCase() === filterColor.toUpperCase() : data.value.toUpperCase() === initialVariationColor.toUpperCase()));
      if (foundColorObject && foundColorObject.value) {
        // check that foundColorObject is truthy and has a .value that is also truthy, if both
        // set activeColorObject to be the foundColorObject
        activeColorObject = foundColorObject;
      }
    }
    this.state = {
      activeColor: activeColorObject.value,
      activeThumbnail: activeColorObject.plp_front_image_url
    };
  }

  handleSelectColor(colorObject) {
    this.setState({
      activeColor: colorObject.value,
      activeThumbnail: colorObject.plp_front_image_url
    });
  }

  handleClick(e, pathname) {
    const { onSetInitialVariationColor } = this.props;
    const { activeColor } = this.state;
    if (activeColor) {
      onSetInitialVariationColor(activeColor);
      e.preventDefault();
      this.handleTrackingProductClickedEvent();
      browserHistory.push(pathname);
    }
  }

  handleTrackingProductClickedEvent() {
    const { handleTrackCardProductClicked, card, basePlanningUrl } = this.props;
    const { suiteUUID, uuid, suiteName, min_price_cents: minPriceCents, type, colors } = card;
    const { urlSlug } = CARD_TYPE[type];
    const { plp_front_image_url: imageUrl } = colors[0];
    const metaData = {
      product_id: suiteUUID,
      sku: uuid,
      category: 'Paper',
      name: suiteName,
      // brand, omitting since does not apply
      variant: uuid,
      price: (minPriceCents / 100).toFixed(2),
      quantity: 1,
      // position, omitting since does not apply
      url: `${basePlanningUrl}/${urlSlug}/${suiteUUID}`,
      image_url: imageUrl || 'N/A',
      location: 'PLP',
      section: null
    };

    handleTrackCardProductClicked({
      name: 'Product Clicked',
      properties: metaData
    });
  }

  render() {
    const { card, basePlanningUrl, shouldExpand, lightView, collaborator } = this.props;
    const { activeColor, activeThumbnail } = this.state;

    const { urlSlug } = CARD_TYPE[card.type];
    const pathname = `${basePlanningUrl}/${urlSlug}/${card.suiteUUID}`;

    const showCollaboratorLink = featureFlags.get('showCollaboratorLink') && collaborator;
    return (
      <div className="listing-detail">
        <Link className="link" to={{ pathname }} onClick={e => this.handleClick(e, pathname)}>
          <div className={`image ${featureFlags.get('PLPImgBigger') ? 'image--is-bigger' : ''}`}>
            {activeThumbnail && (
              <img
                className={shouldExpand ? 'big' : ''}
                src={`${activeThumbnail}?w=465`}
                srcSet={srcsetHelper(activeThumbnail, 465)}
                alt={card.name}
              />
            )}
          </div>
          <div className={`details${showCollaboratorLink ? ' details--less-margin' : ''}`}>
            {showCollaboratorLink && (
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  browserHistory.push(`/wedding-planning/${collaborator.slug}/shop`);
                }}
                className="collaborator-link"
              >
                <strong>Zola</strong> x <strong>{collaborator.label}</strong>
              </div>
            )}
            <p className="product-name gray">{card.suiteName}</p>
            <p className="product-pricing red">From {compactCurrencyFilter(card.min_price_cents / 100)} Ea.</p>
          </div>
        </Link>
        {!lightView && (
          <ProductColorPicker
            colors={card.colors}
            activeColor={activeColor}
            maxColorsToShow={7}
            onSelect={colorObject => this.handleSelectColor(colorObject)}
            link={pathname}
          />
        )}
        {card.foil && (
          <div className="foil-label gold" />
        )}
      </div>
    );
  }
}

ListingDetail.propTypes = {
  card: PropTypes.shape({
    colors: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    foil: PropTypes.bool,
    min_price_cents: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    suiteUUID: PropTypes.string.isRequired,
    type: PropTypes.string,
    uuid: PropTypes.string,
  }).isRequired,
  collaborator: PropTypes.shape({}),
  onSetInitialVariationColor: PropTypes.func.isRequired,
  filterColor: PropTypes.string,
  basePlanningUrl: PropTypes.string,
  shouldExpand: PropTypes.bool,
  initialVariationColor: PropTypes.string,
  lightView: PropTypes.bool,
  handleTrackCardProductClicked: PropTypes.func
};

// export default ListingDetail;



// WEBPACK FOOTER //
// ./src/cards/components/CardListing/ListingDetail/ListingDetail.jsx